import mainStore from '@scoring-web/modules/main/stores/main.store';
import i18n from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';
import { subscribeKey } from 'valtio/utils';
import assessmentJaTranslation from '../../modules/assessment/translations/ja.translation.json';
import mainJaTranslation from '../../modules/main/translations/ja.translation.json';
import userJaTranslation from '../../modules/user/translations/ja.translation.json';
import LocaleOptions from './locale.type';
import commonJaTranslation from './translations/ja.translation.json';

const i18nResources = {
  ja: {
    translation: {
      ...commonJaTranslation,
      ...mainJaTranslation,
      ...assessmentJaTranslation,
      ...userJaTranslation,
    },
  },
};

/**
 * This type is for translation key suggestions.
 * The suggestion sometimes affects the IDE performance.
 * In case any changes in the translation resources affect the performance,
 * you can change this type of definition.
 *
 * The default suggestion handles all languages
 * ```
 * type ResourceTranslationType = typeof resources;
 * ```
 *
 * To disable the suggestion:
 * ```
 * type ResourceTranslationType = string;
 * ```
 *
 * To set the suggestion only for a specific language (e.g English):
 * ```
 * type ResourceTranslationType = typeof resources.ja;
 * ```
 */
type ResourceTranslationType = typeof i18nResources.ja;

i18n.use(initReactI18next).init({
  compatibilityJSON: 'v3',
  fallbackLng: LocaleOptions.JA,
  interpolation: { escapeValue: false },
  lng: mainStore.state.selectedLanguage,
  resources: i18nResources,
  returnNull: false,
});

subscribeKey(mainStore.state, 'selectedLanguage', (value) => i18n.changeLanguage(value));

export { i18n, i18nResources, useTranslation };
export type { ResourceTranslationType };
